export default {
  de: {
    // Globals
    allFlats: 'Anzahl Wohnungen',
    available: 'Erhältlich',
    loading: 'Laden',
    loading_building: 'Laden des 3D-Moduls',
    loading_tour: 'Laden eines virtuellen Spaziergangs',
    back: 'Zurückkehren',
    back2: 'Zurückkehren',

    // Topbar
    choose_city: 'Wählen Sie eine Stadt',
    choose_investment: 'Wählen Sie Investitionen',
    choose_building: 'Wählen Sie eine Gebäude',
    choose_floor: 'Wählen Sie ein Stockwerk',
    choose_flat: 'Wählen Sie eine Wohnung',
    wishlist: 'Wunschzettel',

    // Breadcrumbs
    building: 'Gebäude',
    stage: 'Bühne',
    floor: 'Stockwerke',
    groundFloorShort: 'EG',

    // Legend
    room1: '1-Zimmer',
    room2: '2-Zimmer',
    room3: '3-Zimmer',
    room4: '4-Zimmer',
    room5: '5-Zimmer',

    // Flat
    from: 'von',
    to: 'bis',
    flat: 'Wohnung',
    investment: 'Investition',
    number: 'Nummer',
    area: 'Oberfläche',
    rooms: 'Die Räume',
    balcony: 'Balkon',
    status: 'Status',
    sale: 'Verkauf',
    status_available: 'Verfügbar',
    status_reserved: 'Reserviert',
    status_sold: 'Verkauft',
    status_planned: 'In Plänen',
    hideFilters: 'Filter ausblenden',
    see: 'Siehe',

    surface: 'Bereich',
    numberOfRooms: 'Anzahl der Räume',
    price: 'Preis',
    chooseFromList: 'Wähle aus der Liste...',
    availableFlats: 'Wohnungen verfügbar',
    filterFlats: 'Wohnungen filtern',
    removeFilters: 'Filter entfernen',
    removeAll: 'Alles löschen',
    flatsInWishlist: 'Wohnungen auf wunschliste',
    noWishlistFlats: 'Keine wunschliste wohnungen',
    downloadPDF: 'Herunterladen',

    // Form
    ask: 'Fragen',
    acceptAll: 'Alle Einwilligungen auswählen',
    name: 'Vorname und Nachname',
    surname: 'Nachname',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    message: 'Nachricht',
    nameErrorReq: 'Bitte geben Sie Ihren Vor- und Nachnamen an',
    surnameErrorReq: 'Bitte gib mir deinen Namen',
    emailErrorReq: 'Geben Sie bitte Ihre Email-Adresse ein',
    emailErrorInvalid: 'E-Mail-Adresse ist nicht gültig',
    phoneErrorReq: 'Bitte geben sie ihre Telefonnummer ein',
    phoneErrorInvalid: 'Die Telefonnummer ist ungültig',
    termsErrorReq: 'Bitte die Einwilligungen ankreuzen',
    messageErrorReq: 'Bitte geben Sie eine Nachricht ein',
    sendMessage: 'Senden',
    errorMessage: 'Etwas ist schief gelaufen',
    successMessage: 'Nachricht wurde gesendet!',
    checkOut: 'Prüfen',
    goBackToFlat: 'Zurück zur Wohnungskarte',
    noPreview: 'Keine Vorschau',
    nr: 'Nr',
    pool: 'Schwimmbad',
    lobby: 'Lobby',

    cardView: 'Kartenansicht',
    listView: 'Listenansicht',
    noMatchingFlats: 'Keine Wohnung entspricht Ihren Suchkriterien',
    askAboutFlats: 'Fragen Sie nach Wohnungen',
    askAboutFlat: 'Fragen Sie nach Wohnungen',
  },
};
